import {Pipe, PipeTransform} from '@angular/core';
import {JhiCapitalizePipe} from 'ng-jhipster';

@Pipe({name: 'jhiCapitalize'})
export class CustomCapitalizePipe implements PipeTransform {

    constructor(private capitalizePipe: JhiCapitalizePipe) {
    }

    transform(input: string): string {
        return input.replace(/[^ -]+/g, match => this.capitalizePipe.transform(match));
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/pipes/capitalize.pipe.ts